export const ENDPOINT = {
  PAYMENT_METHOD_LIST: '/payments/list',
  CHECKOUT_ONLINE: '/payments',
  UPDATE_PAYMENT_GATEWAY: '/payments/update_payment_by_gateway',
  RATINGS: '/ratings',
  LOG_CLICK_TO_ICON: 'ratings/click_to_icon',
  RATINGS_WITHOUT_SESSION: '/ratings/create_without_session',
  SERVING_TABLES_LIST: '/serving_tables/list',
  SUBMIT_HOTEL_INFO: '/serving_sessions/submit_hotel_info',
  FOOD_COURTS: 'food_courts',
  CURRENT_INFO: 'serving_sessions/current_info',
  SERVING_REQUESTS: 'serving_requests',
  GET_BADGE_NOTIFY: 'serving_sessions/requests_status_has_changed',
  LOG_EVENT_USER: 'log/user_behavior_log',
  USER_ACTIVITIES: 'user_activities',
  SERVING_SESSION_RECEIPT: 'serving_sessions/serving_session_receipt',
  UPDATE_PHONE_NUMBER: 'serving_sessions/update_phone_number',
  CREATE_SHORT_LINK: 'short_links',
  CHECK_VOUCHER: 'vouchers/check_voucher',
  BIG_CATEGORIES: (restaurant_id) => `restaurants/${restaurant_id}/food_categories/big_categories`,
}
